import i18n from 'i18n-js'
import { Platform } from 'react-native'

/**
 * Translates text.
 *
 * @param key The i18n key.
 */
export function translate(key: string, options?: object): string {
  const { newKey, newOptions } = Platform.select({
    web: { newKey: `${key}_${Platform.OS}`, newOptions: { ...options, defaults: [{ scope: key }] } },
    default: { newKey: key, newOptions: options }
  })
  return key ? i18n.t(newKey, newOptions) : ''
}
